// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { isEmpty } from "@hardwoods/XDL/Utilities/index";

export const emailRegex = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

// ootb phoneRegex
export const phoneRegex = /^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){10,}$/;

// in case we need it in the future
// export const customPhoneRegex = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im);

export const spaceRegex = /\s/g;
export const htmlTagRegex = /(<([^>]+)>)/gi;
export const numberOnlyRegex = /\d+/g;
export const stringOnlyRegex = /^[a-zA-Z]+$/;
export const decimalOnlyRegex = /[\+\-\.\,]$/;
export const qtyRegex = /[^0-9]/g;
export const alphanumericRegex = /^[a-z0-9]+$/i;
export const websiteRegex = /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/;

// This Regex Handle USA and Canada.
export const postalCodeRegex = new RegExp("^([0-9]{5}(-[0-9]{4})?|[a-zA-Z][0-9][a-zA-Z] ?[0-9][a-zA-Z][0-9])$");

export const maxLengthAttr = {
    email: 100,
    userName: 100,
    password: 100,
    qty: 6,
    addToList: 50,
    note: 500,
    smallNote: 300,
    quoteNotes: 500,
    subject: 100,
};

export const userNameValidation = (value: string, isRequired = false) => {
    if (isRequired && isEmpty(value)) {
        return false;
    }
    if (!isRequired && isEmpty(value)) {
        return true;
    }
    return value.length < 256;
};

export const emailValidation = (value: string, isRequired = false) => {
    if (isRequired && isEmpty(value)) {
        return false;
    }
    if (!isRequired && isEmpty(value)) {
        return true;
    }
    return emailRegex.test(value) && value.length <= maxLengthAttr.email;
};

export const phoneNumberValidation = (value: string, isRequired = false) => {
    if (isRequired && isEmpty(value)) {
        return false;
    }
    if (!isRequired && isEmpty(value)) {
        return true;
    }
    return phoneRegex.test(value) && value.length < 256;
};

export const passwordValidation = (value: string, isRequired = false) => {
    if (isRequired && isEmpty(value)) {
        return false;
    }
    if (!isRequired && isEmpty(value)) {
        return true;
    }
    return value.length < 256;
};

export const spaceValidation = (value: string) => {
    return value.indexOf(" ") !== 0 && value.replace(spaceRegex, "").length;
};

export const integerValidation = (value: string) => {
    if (isEmpty(value)) {
        return false;
    }
    return !decimalOnlyRegex.test(value);
};

export const postalCodeValidation = (value: string) => {
    // This Regex Handle USA and Canada.
    return postalCodeRegex.test(value);
};

export const websiteValidation = (value: string) => {
    return websiteRegex.test(value);
};

export const limitMessageValidation = (value: string, maxNumber: number) => {
    if (!value) {
        return true;
    }
    // Remove Tags and break lines
    return value.replace(/<\/?[^>]+(>|$)/g, "").replace(/(\r\n|\n|\r)/gm, "").length > maxNumber;
};
